import { useWorkshopMode } from './WorkshopModeContext'

/** Pill toggle: Simple ⇄ Advanced. Persona-agnostic chrome (no pronouns). */
export function SimpleAdvancedToggle() {
  const { mode, setMode } = useWorkshopMode()
  return (
    <div
      role="group"
      aria-label="Editing detail"
      className="inline-flex items-center rounded-full border border-border bg-muted p-0.5 text-xs"
    >
      <button
        type="button"
        aria-pressed={mode === 'simple'}
        onClick={() => setMode('simple')}
        className={
          mode === 'simple'
            ? 'rounded-full bg-card px-3 py-1 font-medium text-foreground shadow-xs'
            : 'rounded-full px-3 py-1 text-muted-foreground'
        }
      >
        Simple
      </button>
      <button
        type="button"
        aria-pressed={mode === 'advanced'}
        onClick={() => setMode('advanced')}
        className={
          mode === 'advanced'
            ? 'rounded-full bg-card px-3 py-1 font-medium text-foreground shadow-xs'
            : 'rounded-full px-3 py-1 text-muted-foreground'
        }
      >
        Advanced
      </button>
    </div>
  )
}
